import React from "react";

const Footer = () => {
  return (
    <footer>
      <p>copyright &copy; 2020 Roberto Castelli</p>
      <p>robertocastelli.dev</p>
    </footer>
  );
};

export default Footer;
